import { BIZ } from "../data/site";

export const GafCertified = ({ size = "sm", className = "" }) => (
  <a href={BIZ.gaf} target="_blank" rel="noreferrer" title="Verify our GAF certification" className={`inline-flex items-center gap-1.5 ${className}`} data-testid={`gaf-certified-${size}`}>
    <img src="/img/badges/gaf.svg" alt="GAF" className={size === "sm" ? "h-6 w-6" : "h-12 w-12"} />
    <span className="flex flex-col leading-none">
      <span className={`font-display font-black uppercase text-[#d51823] ${size === "sm" ? "text-[11px]" : "text-xl"}`}>Certified™</span>
      <span className={`font-semibold uppercase tracking-wider text-slate-500 ${size === "sm" ? "text-[8px]" : "text-[11px]"}`}>Contractor</span>
    </span>
  </a>
);
